module.exports = __webpack_public_path__ + "static/index-hero_v2-b5d92738f253874df13a57049c025147.mp4";